export interface CoordsConfig {
    name: string;
    email: string;
    linkedin: string;
    github: string;
}

const coordsConfig: CoordsConfig = {
    name: 'Adam Michaud',
    email: 'adam@adammichaud.com',
    linkedin: 'michaudadam',
    github: 'unatiks',
};

export default coordsConfig;
